import dayjs from "dayjs";
import { GlobalStoreContextType } from "../context/GlobalStoreContext";
import Helper from "../Helper";
import { AreaModel } from "./Area.model";
import { MapObject } from "./MapObject";

export class Area extends AreaModel {
    static fromFeature(feature: GeoJSON.Feature, project: any, timezone: string): Area {
        return Area.fromApiObject(
            {
                id: null,
                project_id: project.id,
                is_drop_off: false,
            },
            timezone
        );
    }

    getMapObject(globalStoreContext: GlobalStoreContextType): MapObject | null {
        const projectMapObjects = globalStoreContext.mapObjectsForProject(this.projectId || "");

        const mapObject = projectMapObjects.find(
            (mapObject) => mapObject.mappableType == "Area" && mapObject.mappableId == this.id
        );

        if (mapObject) {
            return mapObject;
        }

        return null;
    }

    openOnDay(checkDate: dayjs.Dayjs | null): boolean {
        if (!checkDate) {
            return true; // If no date is provided, we assume the area is open
        }

        if (this.openDate) {
            if (checkDate.isBefore(dayjs(this.openDate), "day")) {
                return false;
            }
        }

        if (this.closeDate) {
            if (checkDate.isAfter(this.closeDate, "day")) {
                return false;
            }
        }

        for (const exception of this.areaExceptionDays || []) {
            // We should never fail this check, but avoiding bugs from past
            if (!exception.exceptionStart) {
                continue;
            }

            // Adding a timezone signature so that conversions don't change the date because of timezone offsets
            // As in, if we have a date and our current timezone is negative offset from UTC, we end up at the previous day
            const exception_start = dayjs(exception.exceptionStart + "T00:00:00");
            const exception_end = exception.exceptionEnd ? dayjs(exception.exceptionEnd + "T00:00:00") : null;

            if (Helper.dateInsideRange(checkDate, exception_start, exception_end)) {
                return false;
            }
        }

        return true;
    }
}
